<template>
  <div class="el-advanced-user-selector">
    <el-dialog
      custom-class="el-dialog--customize"
      :title="title"
      :visible.sync="dialogVisible"
      :mode="mode"
      width="705px"
      :before-close="closeDialog"
    >
      <div class="left-col">
        <div class="nav-bar">
          <div
            class="icon icon-ccui-downdown nav-tree-chager reverse"
            v-if="isShowGoToBtn"
            @click="goParentNode"
          ></div>
          <div class="breadcrumb" v-show="!isShowSearch">
            <template v-for="(item, key) in fullNamePath">
              <div :key="key" style="display: inline-block">
                <span v-if="key > 0 && key < fullNamePath.length">/</span>
                <span
                  style="cursor: pointer"
                  @click="handlePathClick(item)"
                  :title="item.name"
                  >{{ item.name | cutName }}</span
                >
              </div>
            </template>
          </div>
          <el-autocomplete
            v-show="isShowSearch"
            clearable
            ref="autocompleteInput"
            style="width: 327px; margin: 0"
            popper-class="el-advanced-user-selector"
            prefix-icon="el-icon-search"
            class="inline-input searcher"
            :trigger-on-focus="false"
            v-model="seachData"
            placeholder="请输入姓名定位查找"
            @select="handleSelectAutocomplete"
            :fetch-suggestions="querySearch"
            :scrollBottom="handleScrollBottom"
          >
            <!-- :fetch-suggestions='querySearchAsync' -->
            <template slot-scope="{ item }">
              <div
                :title="item.abbrName + '(' + item.mobile + ')'"
                class="org-name"
              >
                <i :class="setSelectedIcon(item)" class="org-icon"></i>
                <span>{{ item.abbrName }}</span>
              </div>
              <p class="org-full-name" :title="item.orgFullName">
                {{ item.orgFullName }}
              </p>
            </template>
          </el-autocomplete>
          <el-button
            class="search-changer"
            type="text"
            v-show="!isShowSearch"
            @click="handleClickChange"
            >搜索
          </el-button>
          <el-button
            class="search-changer-cancel"
            type="text"
            v-show="isShowSearch"
            @click="handleClickCancel"
            >取消
          </el-button>
          <div class="divider" v-show="!isShowSearch"></div>
        </div>

        <div class="cc_tree-box" id="cc_tree-box">
          <el-tree
            v-if="isShowTree"
            :showLine="showLine"
            :load="loadNode"
            :expand-on-click-node="false"
            ref="tree"
            :props="props"
            :node-key="nodeKey"
            :default-expanded-keys="expandedKeys"
            :default-checked-keys="checkedkeys"
            lazy
            @node-click="handleNodeClick"
            @node-expand="showChildNode"
            :render-content="renderContent"
          >
          </el-tree>
        </div>
      </div>

      <div class="selected" v-loading="loading">
        <p class="selected-count">{{ selectedTitle }}({{ selected.length }})</p>
        <ul class="selected-ul">
          <template v-for="(item, index) in selected">
            <li class="selected-li" :key="index">
              <i
                style="margin-right: 5px"
                :style="{ color: selectedIconColor }"
                :class="setSelectedIcon(item)"
                @click="removeArray(selected, item)"
              ></i>
              <span class="selected-name">{{ item.name }}</span>
              <i
                class="el-icon-close mt"
                v-if="mode === 'checkbox'"
                @click="removeArray(selected, item)"
              ></i>
            </li>
          </template>
        </ul>
      </div>

      <div size="mini" type="default-mini" slot="footer" class="dialog-footer">
        <el-select
          :disabled="partJob"
          @clear="emptyPartJob"
          @visible-change="emptyPartJobChange"
          class="userSelection"
          clearable
          placeholder="请选择兼职部门"
          popper-class="popperTreeSelect"
          ref="selectTree"
          v-model="valueJob"
        >
          <el-option :value="valueJob">
            <el-tree
              v-if="isShowTreeJob"
              :showLine="showLine"
              :load="loadNodeJob"
              :expand-on-click-node="false"
              ref="tree2"
              :props="defaultProps"
              :node-key="nodeKey"
              :default-expanded-keys="expandedKeysJob"
              lazy
              @node-click="handleNodeClickJob"
            >
              <span class="custom-tree-node" slot-scope="{ node }">
                <i :class="iconClass(node.data)" class="orgIcon"></i>
                <span style="margin-left: 10px">{{ node.label }}</span>
                <i
                  class="el-icon-check"
                  style="color: #0089ef; margin-left: 5px"
                  v-if="node.checked"
                ></i>
              </span>
            </el-tree>
          </el-option>
        </el-select>
        <el-button size="mini" type="default-mini" @click="closeDialog"
          >取消
        </el-button>
        <el-button
          :disabled="loading"
          size="mini"
          type="primary-font-mini"
          @click="confirmForm"
          >确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Cookies from "js-cookie";
import {
  checkUserIdExsit
} from "../api/process";
export default {
  name: "ElAdvancedUserSelector",
  props: {
    headers: {
      type: Object,
      default: () => {
        return {
          APP_TOKEN: Cookies.get("appToken"),
          Authorization: Cookies.get("access_token")
        };
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    agentId: {
      type: String,
      default:
        "9F6FD19CCFA4A74EEA3E4B95AF093CFDAA9882717EDF24A0D319F21AE8AE5C6F"
    },
    baseAppId: {
      type: Number,
      default: "100008"
    },
    selectedTitle: {
      type: String,
      default: "已选择成员"
    },
    title: {
      type: String,
      default: "选择成员"
    },

    showLine: {
      type: Boolean,
      defualt: false
    },
    nodeKey: {
      type: String,
      default: "partyId"
    },
    props: {
      type: Object,
      default: () => {
        return {
          label: "abbrName",
          children: "child",
          isLeaf: "isLeaf"
        };
      }
    },
    requestTreeParamConfig: {
      // 接口请求映射表
      type: Object,
      default: function () {
        return { treeId: "partyId", queryId: "parentId" };
      }
    },
    requestResultDataConfig: {
      type: String,
      default: "data"
    },

    selectedIconColor: {
      type: String,
      default: "#0089EF"
    },
    orgId: {
      type: String,
      default: ""
    },
    flag: {
      type: String,
      default: "0"
    },

    selectedData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    mode: {
      validator: value => {
        return ["checkbox", "radio"].includes(value);
      },
      default: "radio"
    }
  },
  data() {
    return {
      isInitLoad: true,
      isShowGoToBtn: false,
      loading: false,
      listSearch: "/apis/basap/basic/listPageSearchMemberFromAll",
      listOrgTreeData: "/apis/basap/basic/listOrgTreeFromAllOne",
      id: "",
      currentNode: {},
      nodeItem: { checked: true },
      expandedKeysNav: [],
      staff: [],
      isTData: {
        isSelected: true
      },
      isGetBread: false,
      fullNamePath: [],
      seachData: "",
      expandedKeys: [],
      checkedkeys: [],
      treeData: [],
      selected: [],
      firstCode: "",
      nodeseachItem: { isSelected: true },
      selectedCode: [],
      selectedCodeNav: [],
      renderParams: {},
      renderParamsNav: {},
      resolve: Function,
      ishowTree: true,
      expandedlog: {},
      treedata: {},
      expandArr: [],
      isShowTree: true,
      isShowTreeNav: false,
      isShowSearch: false,
      params: {
        agentId: this.agentId,
        baseAppId: this.agentId,
        pageNo: 1,
        pageSize: 20,
        parentId: "",
        flag: "0" // 0 公司 1 部门 2 成员
      },
      paramsNav: {
        agentId: this.agentId,
        baseAppId: this.agentId,
        pageNo: 1,
        pageSize: 20,
        parentId: "199999",
        flag: "0" // 0 公司 1 部门 2 成员
      },
      paramSearch: {
        agentId: this.agentId,
        baseAppId: this.baseAppId,
        flag: 0,
        pageNo: 1,
        pageSize: 20
      },
      defaultProps: {
        label: "abbrName",
        children: "child",
        isLeaf: "isLeaf"
      },

      //  兼职部门禁用
      partJob: true,
      valueJob: "",
      userID: "",
      isShowTreeJob: false,
      renderParamsJob: {},
      expandedKeysJob: [],
      paramsJob: {
        agentId: this.agentId,
        baseAppId: this.agentId,
        pageNo: 1,
        pageSize: 20,
        parentId: "",
        flag: "1" // 0 公司 1 部门 2 成员
      }
    };
  },
  watch: {
    dialogVisible(arr) {
      if (this.dialogVisible) {
        this.params.parentId = "";
        this.renderParamsNav = this.paramsNav;
        this.renderParamsNav.parentId = "199999";
        this.renderParams = this.params;
        this.renderParamsJob = this.paramsJob;
        this.selectedCode = [];
        this.expandArr = [];
        this.expandedKeys = [];
        this.selected = [];
        this.isShowTree = true;
        this.isShowTreeNav = false;
        this.isInitLoad = true;
        this.partJob = true;
        this.isShowTreeJob = true;
        this.expandedKeysJob = [];
        this.nodeItem = { checked: true };
        this.staff = [];
      }
    },
    isShowTree() {
      if (this.isShowTree) {
        this.renderParams = this.params;
        this.isGetBread = false;
      }
      this.selected = this.unique(this.selected);
    },
    isShowTreeNav() {
      if (this.isShowTree) {
        this.renderParamsNav = this.paramsNav;
        this.isGetBread = false;
      }
    },
    partJob(e) {
      console.log(e);
      if (e) {
        this.emptyPartJob();
      }
    }
  },
  mounted() { },
  methods: {
    checkUserIdExsit(userID) {
      let orgID = this.$store.getters.userDetal.orgId + "";
      checkUserIdExsit({ orgID, userID }).then(res => {
        console.log("res.data.isCheck", res.data.data);
        this.partJob = !res.data.data.isCheck;
        this.userID = res.data.data.userID;
      })
    },
    // 清空兼职
    emptyPartJob() {
      this.nodeItem = { checked: true };
      this.staff = [];
      this.valueJob = "";
      this.isShowTreeJob = false;
    },
    emptyPartJobChange(e) {
      if (e) {
        this.isShowTreeJob = true;
      }
    },
    unique(arr) {
      // 根据唯一标识orderId来对数组进行过滤
      if (arr) {
        const res = new Map(); // 定义常量 res,值为一个Map对象实例
        // 返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
        return arr.filter(
          arr => !res.has(arr.autoCode) && res.set(arr.autoCode, 1)
        );
      }
    },
    addUrlPerFix(url) {
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "ccui.iccec.cn"
      ) {
        return window.location.protocol + "//dev01-" + "basap.iccec.cn" + url;
      } else {
        let arr = window.location.hostname.split("-");
        let perfix = arr.length === 1 ? "" : arr[0] + "-";
        return (
          window.location.protocol + "//" + perfix + "basap.iccec.cn" + url
        );
      }
    },
    goParentNode() {
      const str = this.currentNode.data.orgAutoCode;
      const arr = str.split("-");
      arr.pop();
      arr.shift();
      // debugger;
      const parentNodeCode = arr.pop();
      // this.$refs.tree.setCurrentKey(parentNodeCode);
      this.scrollToNode(false, parentNodeCode);
      // debugger
    },
    handleClickCancel() {
      setTimeout(() => {
        this.$refs.autocompleteInput.blur;
        this.isShowSearch = false;

      }, 300)
    },
    handleClickChange() {
      setTimeout(() => {
        this.isShowSearch = true;
        this.isShowTreeNav = false;
      })

    },
    handlePathClick(obj) {
      this.getBreadcrumbByData(obj, true);
      let id = obj.id === "" ? 199999 : obj.id;
      this.$refs.tree.setCurrentKey(id);
      this.scrollToNode(id);
      this.isGetBread = false;
      this.currentNode = this.$refs.tree.getNode(id);
      // const autoCode = obj.autoCode;
    },
    setSelectedIcon({ sex }) {
      if (sex === "2") {
        return "icon-ccui-woman-hollow";
      } else {
        return "icon-ccui-man-hollow";
      }
    },
    setTreeICon(node, data) {
      if (data.orgType === "2") {
        if (data.sex === "2") {
          return "icon-ccui-woman-hollow is-leaf-org";
        } else if (data.sex === "1") {
          return "icon-ccui-man-hollow is-leaf-org";
        } else {
          return "icon-ccui-man-hollow is-leaf-org";
        }
      }
      if (data.orgType === "0") {
        return "icon-ccui-organization is-leaf-org";
      }
      if (data.orgType === "1") {
        return "icon-ccui-unit is-leaf-org";
      }
    },
    setTreeICon2(h, node, data, store) {
      if (data.orgType === "2") {
        if (data.sex === "2") {
          return <i class="icon-ccui-woman-hollow is-leaf-org" />;
        } else if (data.sex === "1") {
          return <i class="icon-ccui-man-hollow is-leaf-org" />;
        } else {
          return <i class="icon-ccui-man-hollow is-leaf-org" />;
        }
      }
      if (data.orgType === "0") {
        return <i class="icon-ccui-organization is-leaf-org" />;
      }
      if (data.orgType === "1") {
        return <i class="icon-ccui-unit is-leaf-org" />;
      }
    },
    showDialogInventory() {
      this.dialogVisible = true;
      this.$emit("update:dialogVisible", true);
    },
    handleScrollBottom(data, callback) {
      let params = Object.assign({}, this.paramSearch);
      params.pageNo++;
      params.flag = this.flag;
      params["branchName"] = this.seachData;
      this.$refs.autocompleteInput.loading2 = true;
      if (!this.seachData) return;
      Axios({
        method: "post",
        url: this.addUrlPerFix(this.listSearch),
        headers: this.headers,
        data: params
      }).then(res => {
        let dataRows = res.data.data.rows;
        console.log(dataRows.length);
        setTimeout(() => {
          this.$refs.autocompleteInput.loading2 = false;
        }, 300)
        if (dataRows.length !== 0) {
          callback(dataRows);
        }
      });
    },
    handleSelectAutocomplete(data) {
      // debugger
      // if (seachItem.orgId == this.$store.getters.userDetal.orgId) {
      //   this.partJob = true;
      // } else {
      //   this.partJob = false;
      // }
      if (this.selected.length > 0) {
        this.selected[0].isSelected = false;
      }
      console.log(data);
      let seachItem = this.$refs.tree.getNode(data.id) ? this.$refs.tree.getNode(data.id).data : data;
      this.nodeseachItem = seachItem;
      this.renderParams = this.params;
      this.expandedKeys = [];
      let idArr = seachItem.autoCode.split("-");
      idArr.shift(); // 去掉租户
      idArr.pop(); // 去掉空串
      idArr.pop(); // 去掉空串
      // idArr = idArr.slice(idArr.indexOf(this.orgId), idArr.length - 1);
      let id = idArr[0];
      this.isInitLoad = true;
      this.expandedKeys = idArr;
      setTimeout(() => {
        // 选择人员的autoCode
        this.isShowTree = true;
        seachItem.isSelected = true;
        this.selectedCode = [seachItem.autoCode];
        this.isShowSearch = false;
        let userId = seachItem.userId || seachItem.userID
        this.checkUserIdExsit(userId);
        this.loading = false;
        if (this.mode === "radio") {
          this.selectedCode = [];
          let idArrobj = [];
          idArrobj.push(idArr[idArr.length - 2]);
          this.checkedkeys = [...idArrobj];
          let seachItemobj = [];
          seachItemobj.push(seachItem);
          this.selected = [...seachItemobj];
          let selectedCodeobj = [];
          selectedCodeobj.push(seachItem.autoCode);
          this.selectedCode = [...selectedCodeobj];
        } else {
          this.selected.push(seachItem);

          this.selectedCode.includes(seachItem.autoCode) ||
            this.selectedCode.push(seachItem.autoCode);
        }
      }, 300);
      this.loading = true;
      this.selected = this.unique(this.selected);
    },
    querySearch(queryString, cb) {
      let params = Object.assign({}, this.paramSearch);
      this.seachData = queryString;
      console.log("queryString", queryString);
      if (queryString === '') return;
      params["branchName"] = queryString;
      params.flag = this.flag;
      Axios({
        method: "post",
        url: this.addUrlPerFix(this.listSearch),
        headers: this.headers,
        data: params
      })
        .then(res => {
          setTimeout(() => {
            this.$refs.autocompleteInput.loading2 = false;
          })
          cb(res.data.data.rows);
          // params.pageNo++;
        })
        .catch(e => { });
    },
    getBreadcrumb(res) {
      // if (!this.isGetBread) {
      // debugger
      const obj = res.data.data[0];
      this.fullNamePath = [];
      const arr = obj.orgFullName.split("/");
      arr.shift(); // 去掉租户
      let orgAutoCode;
      switch (obj.orgType) {
        case "0": {
          // 单位
          orgAutoCode = obj.autoCode;
          break;
        }
        case "1":
        case "2": {
          orgAutoCode = obj.orgAutoCode;
        }
      }
      // const orgAutoCode = res.data.data[0].orgAutoCode;
      // debugger;
      const idArr = orgAutoCode.split("-");
      idArr.shift(); // 去掉租户
      idArr.pop(); // 去掉最后一位
      const pathArr = [];
      let lastUnitKey = idArr.length - 1;
      let firstUnitKey = idArr.length - 3;
      for (let i = lastUnitKey; i >= firstUnitKey && i >= 0; i--) {
        const newObj = {};
        newObj.id = idArr[i];
        newObj.name = arr[i];
        newObj.orgFullName = this.getFullName(arr, i);
        newObj.orgType = "0";
        newObj.autoCode = this.getAutoCode(idArr, i);
        if (newObj.id !== "100001") {
          pathArr.push(newObj);
        }
      }
      // debugger;
      this.fullNamePath = pathArr.reverse();
      this.isGetBread = true;
      // }
    },
    getAutoCode(idArr, i) {
      let len = idArr.length;
      let str = "";
      for (let j = 0; j <= i; j++) {
        if (idArr[len - 1] !== "-") {
          str += idArr[j] + "-";
        }
      }
      return str;
    },
    getFullName(arr, i) {
      let len = arr.length;
      let str = "";
      for (let j = 0; j <= i; j++) {
        str += j === 0 ? arr[j] : "/" + arr[j];
      }
      return str;
    },
    // type true为点击面包屑
    getBreadcrumbByData(obj, type) {
      // debugger;
      this.fullNamePath = [];
      const arr = obj.orgFullName.split("/");
      if (!type) {
        arr.shift(); // 去掉租户
      }
      // arr.shift(); // 去掉租户

      const autoCode = obj.autoCode;
      let orgAutoCode;
      switch (
      obj.orgType // 单位时用autoCode
      ) {
        case "0": {
          if (type) {
            orgAutoCode = obj.autoCode;
          } else {
            orgAutoCode = obj.autoCode;
          }

          break;
        }
        case "1":
        case "2": {
          orgAutoCode = obj.orgAutoCode;
        }
      }
      const idArr = orgAutoCode.split("-");
      // debugger
      if (!type) {
        // 点击面包屑不用去掉租户
        idArr.shift(); // 去掉租户
      }
      idArr.pop();

      const pathArr = [];
      let lastUnitKey = idArr.length - 1;
      let firstUnitKey = idArr.length - 3;
      for (let i = lastUnitKey; i >= firstUnitKey && i >= 0; i--) {
        const newObj = {};
        newObj.id = idArr[i];
        newObj.orgType = "0";
        newObj.orgFullName = this.getFullName(arr, i);
        newObj.name = arr[i];
        newObj.autoCode = this.getAutoCode(idArr, i);
        if (newObj.id !== "100001") {
          pathArr.push(newObj);
        }
      }
      // debugger;
      this.fullNamePath = pathArr.reverse();
      if (this.fullNamePath.length === 1) {
        this.isShowGoToBtn = false;
      }
      if (type) {
        this.scrollToNode(true);
      }
    },
    loadNodeNav(node, resolve) {
      // debugger
      if (node.level === 0) {
        // const that = this;
        this.renderParamsNav.parentId = "199999";
        Axios({
          method: "post",
          url: this.addUrlPerFix(this.listOrgTreeData),
          headers: this.headers,
          data: this.renderParamsNav
        }).then(res => {
          // this.getBreadcrumb(res);
          this.treeData = res.data[this.requestResultDataConfig];
          resolve(this.treeData);
        });
      }
      if (node.level > 0) {
        // debugger
        let cloneParams = Object.assign({}, this.renderParamsNav);
        let treeId = this.requestTreeParamConfig.treeId;
        let queryId = this.requestTreeParamConfig.queryId;
        cloneParams[queryId] = node.data[treeId];
        Axios({
          method: "post",
          url: this.addUrlPerFix(this.listOrgTreeData),
          headers: this.headers,
          data: cloneParams
        }).then(res => {
          this.getBreadcrumb(res);
          let resolveData = res.data.data[0].child;
          resolve(resolveData);
        });
      }
    },
    loadNode(node, resolve) {
      // debugger;

      if (node.level === 0) {
        this.expandArr = [];
        // const that = this;
        // this.renderParams.parentId = "199999"
        Axios({
          method: "post",
          url: this.addUrlPerFix(this.listOrgTreeData),
          headers: this.headers,
          data: this.renderParams
        }).then(res => {
          // debugger
          this.getBreadcrumb(res);
          this.treeData = res.data[this.requestResultDataConfig];
          this.expandedKeys = ["199999"];
          this.firstCode =
            this.treeData[0].partyId !== "" && this.treeData[0].partyId;
          if (this.selectedCode.length > 0) {
            // this.formatSelectedData(this.selectedCode);
          } else {
            // debugger;
            if (this.renderParams.parentId === "") {
              if (this.treeData[0] && this.treeData[0].userOrgAutoCode) {
                // debugger
                const arr = this.treeData[0].userOrgAutoCode.split("-");
                arr.shift(); // 去掉100001
                arr.pop(); // 去掉空串
                // debugger
                this.expandedKeys = arr;
              }
            }
          }
          this.expandArr.push(...this.treeData);

          resolve(this.treeData);
        });
      }

      if (node.level > 0) {
        // debugger;
        let cloneParams = Object.assign({}, this.renderParams);
        let treeId = this.requestTreeParamConfig.treeId;
        let queryId = this.requestTreeParamConfig.queryId;
        cloneParams[queryId] = node.data[treeId];
        Axios({
          method: "post",
          url: this.addUrlPerFix(this.listOrgTreeData),
          headers: this.headers,
          data: cloneParams
        }).then(res => {
          if (this.isInitLoad) {
            this.getBreadcrumb(res);
          }

          let resolveData = res.data.data[0].child;
          this.setIsSelected(resolveData);
          this.expandArr.push(...resolveData);
          const arr = this.expandedKeys;
          const len = this.expandedKeys.length;
          this.$nextTick(() => {
            this.setIsSelected(this.expandArr);
            const lastKey = arr[len - 1];
            if (node.data[treeId] === lastKey) {
              // 只有最后一次才生效
              // debugger;
              this.currentNode = this.$refs.tree.getNode(lastKey);
              setTimeout(() => {
                this.scrollToNode();
                this.loading = false;
              }, 400); // nextTick并不能保证，所以加延时
              this.isInitLoad = false; //
              this.isShowGoToBtn = true; //
            }
          });
          resolve(resolveData);
        });
      }
    },
    scrollToNode(type, id) {
      // 点击面包屑时 type为 true
      let lastKey;
      if (!id) {
        if (type) {
          lastKey = this.fullNamePath[this.fullNamePath.length - 1].id;
        } else {
          lastKey = this.expandedKeys[this.expandedKeys.length - 1];
        }
      } else {
        lastKey = id;
      }

      const lastNodeId = "cc_tree-" + lastKey;
      const el = document.getElementById(lastNodeId).parentNode.parentNode;
      document.getElementById("cc_tree-box").scrollTo(0, el.offsetTop + 11);
      this.$refs.tree.setCurrentKey(lastKey);
      this.currentNode = this.$refs.tree.getNode(lastKey);
      // this.fullNamePath.pop();
      // debugger
      if (id) {
        // debugger
        if (id === "199999") {
          this.isShowGoToBtn = false;
        }
        this.getBreadcrumbByData(
          this.currentNode.data,
          this.currentNode.data.orgType
        );
      }
    },
    closeDialog() {
      this.isShow = false;
      this.isGetBread = false;
      this.isShowSearch = false;
      this.isShowTree = false;
      this.$emit("update:dialogVisible", false);
    },

    confirmForm() {
      console.log(this.selected,
        this.partJob,
        this.staff);
      this.$emit(
        "selectedUserSuccess",
        this.selected,
        this.partJob,
        this.staff,
        this.userID

      );
      if (this.partJob) {
        this.closeDialog();
      }
      if (!this.partJob && this.staff.length !== 0) {
        this.closeDialog();
      }
    },
    renderContent(h, { node, data, store }) {
      // debugger
      let isSelectedHtml;
      if (data.isSelected) {
        isSelectedHtml = <i class="el-icon-check" style="margin-right:15px" />;
      }
      return (
        <span
          style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;"
          id={"cc_tree-" + data.partyId}
        >
          <span>
            {this.setTreeICon2(h, node, data, store)}
            <span>{node.label}</span>
          </span>
          <span>{isSelectedHtml}</span>
        </span>
      );
    },
    showChildNode(data, node) { },
    handleNodeClick(data, node, tree) {
      // debugger;
      console.log("data", data);
      console.log("orgId", this.$store.getters.userDetal.orgId);
      // if (data.orgType === "2") {
      //   if (data.orgId == this.$store.getters.userDetal.orgId) {
      //     this.partJob = true;
      //   } else {
      //     this.partJob = false;
      //   }
      // }
      if (this.fullNamePath.length) {
        this.isShowGoToBtn = true;
      }

      // todo
      console.log(this.$refs.tree.getNode(data.partyId));
      // if (node.orgType === "0") {
      //   this.currentNode = node;
      // } else {
      //   const str = node.data.orgAutoCode;
      //   const arr = str.split("-");
      //   arr.pop();
      //   const unitCode = arr.pop(); // 当前节点的单位code
      //   this.currentNode = this.$refs.tree.getNode(data.partyId); // 获取当前节点的单位节点
      //   // debugger
      // }
      // orgType为0时

      this.getBreadcrumbByData(data);
      console.log(this.$refs.tree.getNode(data.partyId));
      if (this.mode === "radio") {
        if (data.isLeaf && data.orgType === "2") {
          this.checkUserIdExsit(data.userId);
          if (!data.isSelected) {
            data.isSelected = true;
            this.selected.forEach(item => (item.isSelected = false));
            this.$refs.tree.setCheckedKeys([]);
            this.$refs.tree.setChecked(data, true);
            let dataobj = [];
            dataobj.push(data);
            this.selected = [...dataobj];
            let autoCodeobj = [];
            autoCodeobj.push(data.autoCode);
            this.selectedCode = [...autoCodeobj];
          } else {
            this.$refs.tree.setCheckedKeys([]);
            this.$refs.tree.setChecked(data, false);
            this.removeArray(this.selected, data);
          }
          this.isTData = data;
        }
      } else {
        if (data.isLeaf && data.orgType === "2") {
          if (!data.isSelected) {
            data.isSelected = true;
            this.$refs.tree.setChecked(data, true);
            this.selected.push(data);
            this.selectedCode.push(data.autoCode);
          } else {
            this.removeArray(this.selected, data);
            this.$refs.tree.setChecked(data, false);
          }
        }
      }
    },
    setIsSelected(arr) {
      arr.map(item => {
        if (this.selectedCode.includes(item.autoCode)) {
          item.isSelected = true;
          let reslut = this.selected.some(({ autoCode }, i, thisarr) => {
            if (autoCode === item.autoCode) {
              thisarr.splice(i, 1, item);
              return true;
            }
          });
          reslut || this.selected.push(item);
        } else {
          item.isSelected = false;
        }
      });
    },
    removeArray(arr, delItem) {
      let condeIndex = this.selectedCode.indexOf(delItem.autoCode);
      this.selectedCode.splice(condeIndex, 1);
      this.$refs.tree.setChecked(delItem, false);
      this.checkedkeys = this.checkedkeys.filter(i => i !== delItem.partyId);
      delItem.isSelected = false;
      let index = arr.indexOf(delItem);
      arr.splice(index, 1);
    },
    iconClass(i) {
      let arr = [
        "icon-ccui-organization",
        "icon-ccui-unit",
        "icon-ccui-man-hollow",
        "icon-ccui-woman-hollow"
      ];
      let keyClass = "";
      if (i.orgType === "2") {
        keyClass = arr[Number(i.orgType) + Number(i.sex) - 1];
      } else {
        keyClass = arr[i.orgType];
      }

      let obj = {};
      obj[keyClass] = true;
      return obj;
    },
    loadNodeJob(node, resolve) {
      if (node.level === 0) {
        this.expandArr = [];
        // const that = this;
        // this.renderParams.parentId = "199999"
        Axios({
          method: "post",
          url: this.addUrlPerFix("/apis/basap/basic/listDeptTreeFromOrg"),
          headers: this.headers,
          data: this.renderParamsJob
        }).then(res => {
          // debugger
          // this.getBreadcrumb(res);
          this.treeData = res.data[this.requestResultDataConfig];
          console.log("treeData", this.treeData);
          this.expandedKeysJob = ["117158"];
          this.firstCode =
            this.treeData[0].partyId !== "" && this.treeData[0].partyId;
          if (this.selectedCode.length > 0) {
            // this.formatSelectedData(this.selectedCode);
          } else {
            // debugger;
            if (this.renderParamsJob.parentId === "") {
              if (this.treeData[0] && this.treeData[0].userOrgAutoCode) {
                // debugger
                const arr = this.treeData[0].userOrgAutoCode.split("-");
                arr.shift(); // 去掉100001
                arr.pop(); // 去掉空串
                // debugger
                this.expandedKeys = arr;
              }
            }
          }
          this.expandArr.push(...this.treeData);

          resolve(this.treeData);
        });
      }

      if (node.level > 0) {
        // debugger;
        let cloneParams = Object.assign({}, this.renderParamsJob);
        let treeId = this.requestTreeParamConfig.treeId;
        let queryId = this.requestTreeParamConfig.queryId;
        cloneParams[queryId] = node.data[treeId];
        Axios({
          method: "post",
          url: this.addUrlPerFix("/apis/basap/basic/listDeptTreeFromOrg"),
          headers: this.headers,
          data: cloneParams
        }).then(res => {
          let resolveData = res.data.data[0].child;
          // this.setIsSelected(resolveData);
          // this.expandArr.push(...resolveData);
          // const arr = this.expandedKeys;
          // const len = this.expandedKeys.length;
          // this.$nextTick(() => {
          //   this.setIsSelected(this.expandArr);
          //   const lastKey = arr[len - 1];
          //   if (node.data[treeId] === lastKey) {
          //     // 只有最后一次才生效
          //     // debugger;
          //     this.currentNode = this.$refs.tree.getNode(lastKey);
          //     setTimeout(() => {
          //       this.scrollToNode();
          //     }, 400); // nextTick并不能保证，所以加延时
          //     this.isInitLoad = false; //
          //     this.isShowGoToBtn = true; //
          //   }
          // });
          resolve(resolveData);
        });
      }
    },
    handleNodeClickJob(obj, node, tree) {
      this.nodeItem.checked = false;
      if (obj.orgType === "1") {
        this.$set(node, "checked", true);
        this.staff = obj;
        this.$refs.selectTree.blur();
        this.valueJob = obj.name;
        this.nodeItem = node;
        // this.checkUserIdExsit()
        console.log("选中的22", this.staff);
      }
    }
  },
  filters: {
    cutName(value) {
      return value.length > 6 ? value.substring(0, 6) + "..." : value;
    }
  }
};
</script>
<style lang="scss" scoped>
.userSelection {
  width: 200px;
  float: left;
}
/deep/.el-tree-node__content span span i {
  margin-right: 5px;
  color: #0089ef;
}
</style>
